import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { IPage } from '@models/pagination/page';
import { extractResponse } from '@shared/rxjs/custom-rxjs-operators';
import { IResponseDto } from '../../models/exceptions/response-dto';
import { toParams } from '../../utilities/utility-functions';
import { IPageable } from '@models/pagination/pageable';
import { ContaBancariaDto } from '@models/portal/users/dtos/user-relationship-dto';

@Injectable({
  providedIn: 'root',
})
export class BancoService {
  #baseUrl = environment.apiUrl + '/v1/bancos';
  #http = inject(HttpClient);

  buscarBancos(filter: IBancoFilter, pageable: IPageable): Observable<IPage<BancoDto>> {
    const params = toParams(filter, pageable);
    return this.#http.get<IResponseDto<IPage<BancoDto>>>(this.#baseUrl, { params }).pipe(
      extractResponse()
    );
  }
  buscarBancoPorId(banNrId: number): Observable<BancoDto> {
    return this.#http.get<IResponseDto<BancoDto>>(this.#baseUrl + `/${banNrId}`).pipe(
      extractResponse()
    );
  }
}
export interface IBancoFilter {
  banNrId?: number;
  banTxNome?: string;
  banTxCodigo?: string;
}
export interface BancoDto {
  banNrId: number;
  banTxNome: string;
  banTxCnpj: string;
  banTxCodigo: string;
}
